import { useMemo, useState } from 'react';
import type { Controller } from '../host/controller';
import { getBetaFeedbackConfiguration } from './betaFeedback';
import { FeedbackModal } from './FeedbackModal';
import { NameSuggestionModal } from './NameSuggestionModal';
import {resolveAgentContent} from '../content';

type ActiveModal = 'nameSuggestion' | 'feedback' | null;

/** Temporary beta actions isolated from the conversation and host event API. */
export function BetaFeedbackActions({ controller }: { controller: Controller }) {
  const configuration = useMemo(() => getBetaFeedbackConfiguration(controller.options), [controller]);
  const actionsContent = resolveAgentContent().supportingActions;
  const [activeModal, setActiveModal] = useState<ActiveModal>(null);

  if (!configuration.enabled) return null;

  const close = () => setActiveModal(null);
  const getThreadId = () => controller.bus.context.threadId;

  return (
    <>
      <div className="twe-asa-beta-actions" aria-label={actionsContent.ariaLabel}>
        <button type="button" className="cta-button twe-asa-beta-action" onClick={() => setActiveModal('nameSuggestion')}>{actionsContent.suggestNameButtonText}</button>
        <button type="button" className="cta-button twe-asa-beta-action" onClick={() => setActiveModal('feedback')}>{actionsContent.submitFeedbackButtonText}</button>
      </div>
      <NameSuggestionModal
        open={activeModal === 'nameSuggestion'}
        endpoint={configuration.nameSuggestionFormEndpoint}
        getThreadId={getThreadId}
        onClose={close}
      />
      <FeedbackModal
        open={activeModal === 'feedback'}
        endpoint={configuration.feedbackFormEndpoint}
        getThreadId={getThreadId}
        onClose={close}
      />
    </>
  );
}
